import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject, OnInit, Type } from '@angular/core';
import { catchError, combineLatest, map, Observable, of, shareReplay, switchMap, tap } from 'rxjs';
import { PanelService } from 'src/app/dashboards/panels/services/panel/panel.service';
import { VisibleDirective, waitUntilVisible } from 'src/app/panels/directives/visible/visible.directive';
import { NumberPipe } from 'src/app/panels/pipes/number/number.pipe';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ErrorMessageComponent } from 'src/app/shared/components/error-message/error-message.component';
import { MessageComponent } from 'src/app/shared/components/message/message.component';
import { ColorService } from 'src/app/shared/services/color/color.service';
import { Color } from 'src/app/shared/services/color/colors';
import { DisplayUnit } from '../../../models/display-unit';
import { IPieChartData } from '../../../models/pie';
import { PanelComponent } from '../../panel.component';

export const LIST_PANEL_IMPORTS: Type<unknown>[] = [
  CardComponent,
  VisibleDirective,
  ErrorMessageComponent,
  AsyncPipe,
  NumberPipe,
  MessageComponent,
];

@Component({
  selector: 'app-list-panel',
  template: '',
})
export abstract class ListPanelComponent extends PanelComponent implements OnInit {
  @HostBinding('class') public class = 'col-12 col-lg-6';

  public override data$?: Observable<IPieChartData | null>;
  public color: Color = Color.Blue;

  protected empty: boolean = false;
  protected panelService = inject(PanelService);

  private colors = inject(ColorService).getColors();

  public abstract readonly unit?: DisplayUnit;
  public abstract override readonly icon?: string;

  ngOnInit(): void {
    this.data$ = combineLatest([this.dashboardParams$, this.visible$]).pipe(
      waitUntilVisible(this),
      switchMap((params) => {
        return this.panelService
          .getPie(
            this.getType(),
            this.entityIds,
            params.timeRange.from,
            params.timeRange.till,
            params.timeRange.compareFrom,
            params.timeRange.compareTill,
          )
          .pipe(
            catchError(() => {
              this.error = 'Geen data';
              return of(null);
            }),
          );
      }),
      map(
        (x) =>
          ({
            unit: this.unit,
            values: x?.map((v) => ({
              label: v.key,
              value: v.value,
              percentage: v.percentage,
            })),
          }) as IPieChartData,
      ),
      tap(() => (this.loading = false)),
      tap((data) => (this.empty = !data?.values?.length)),
      shareReplay(1),
    );
  }

  protected getColor(index: number): string {
    return this.colors[index % this.colors.length];
  }
}
